import { useState, useRef, useEffect } from "react";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import { checkImage } from "../../constants/checkImage";
import ConstantStrings from "../../constants/ConstantStrings";
import { loadWidthImage } from "../../constants/loadWidthImage";
import QuestionNumberTag from "../../detail-components/QuestionNumberTag";
import ScrollRef from "../../detail-components/ScrollRef";
import { cacheImage, getCacheImage, getImageUrl } from "../helper/parseImage";
import AudioIcon, {useAutoPlayAudio, handleClickAudio} from "./Assets/AudioIcon";

function QPrompt3_2({ data, order, isLast, playingAudioRef }) {
  const content = data?.content || data?.prompt;
  const [isLoading, setIsLoading] = useState(
    checkImage(content?.images[0])
      ? getCacheImage([content?.images[0]])
        ? false
        : true
      : false
  );
  var key = getImageUrl(content?.images[0]);
  useEffect(() => {
    loadWidthImage(key, (err, img) => {
      cacheImage([key]);
      setIsLoading(false);
    });
  }, [key]);

  const audioLink = content?.audioLink;
  const audioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + audioLink));
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useAutoPlayAudio({
    content,
    audioRef,
    playingAudioRef,
    setIsAudioPlaying,
    slideId: data?._id || data.questionId,
    type: 0
  });
 
  return (
    <div>
      {!isLast &&
        !isLoading && <ScrollRef />}
      <BackgroundImageFromUrl
        objectId={content?.backgroundImage}
        className={`${isLoading ? "is-hidden" : ""
          }  has-text-centered has-background-kurio-main-color-white is-flex is-flex-direction-column is-justify-content-center is-align-items-center `}
        style={{
          borderRadius: "1rem 1rem 0 0",
          padding: "2rem",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {data?.template.question !== null &&
          data?.template.question &&
          data?.template.question.length > 0 && (
            <div className="mb-4">
              <QuestionNumberTag number={order === 0 ? data?.order : order} />
            </div>
          )}
        <div className={`content-image`}>
          {audioLink && playingAudioRef && <AudioIcon isPlaying={isAudioPlaying} onClick={() => handleClickAudio(audioRef, setIsAudioPlaying)} />}
          <img src={getImageUrl(content?.images[0])} alt={content?.images[0]} onError={(e)=>{ e.target.src = ConstantStrings.DEFAULT_IMAGE;e.target.style.width = "2.5rem";e.target.style.height = "2.5rem"; }} />
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

export default QPrompt3_2;
